import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import factorFactory from '../models/vendorCostFactor';
import { Confirm, NumericInput, Popup } from './sharedComponents';

class FactorRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { shouldValidate: props.alwaysValidate };

		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.updateModel = this.updateModel.bind(this);
	}

	updateModel (path, autoSave, e) {
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	validate (property?) {
		if (!property || this.state.shouldValidate) {
			const result = !this.props.factor.test(property);

			return result;
		}
		return true;
	}

	handleButtonClick (e) {
		e.preventDefault();

		const valid = this.validate();

		if (!valid) {
			this.setState({ shouldValidate: true });
		}
		else {
			// this assumes that the add handler succeeds
			this.setState({ shouldValidate: this.props.alwaysValidate });
		}

		this.props.buttonHandler(valid, e);
	}

	render () {
		const { classNames = [], buttonClass, factor } = this.props;

		return 	(<tr className={classNames.join(' ')}>
			<td />
			<td className={ this.validate('description') ? '' : 'required' }><input type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" value={ factor.viewValue('description') } onChange={ this.updateModel.bind(this, 'description', false) } onBlur={ this.updateModel.bind(this, 'description', true) } /></td>
			<td className={ this.validate('value') ? 'value' : 'value required' }><NumericInput placeholder="0.00" value={ factor.viewValue('value') } onChange={ this.updateModel.bind(this, 'value', false) } onBlur={ this.updateModel.bind(this, 'value', true) } /></td>
			<td><button className={ buttonClass } onClick={ this.handleButtonClick }><span /></button></td>
			<td />
		</tr>);
	}
}

export default class VendorFactors extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);
	}

	getStateFromProps (props) {
		const state = _.assign({}, this.state);

		if (!state.pendingFactor || state.pendingFactor.type !== props.type) {
			state.pendingFactor = this.createPendingLineItem();
		}

		return state;
	}

	addLineItemHandler (key, isValid) {
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		if (!isValid || readOnly) {
			return;
		}

		this.props.updateModel(vendor => {
			if (key === this.state.pendingFactor.key) {
				vendor.costFactors.push(this.state.pendingFactor);
				vendor.costFactorJson = JSON.stringify(vendor.costFactors);

				this.setState({ pendingFactor: this.createPendingLineItem() });
			}
		}, { autoSave: true });
	}

	contextMenuHandler (factor, isValid, e) {
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		if (readOnly) { return; }

		const doDelete = () => {
			this.props.updateModel(vendor => {
				const index = _.findIndex(vendor.costFactors, f => f.key === factor.key);

				vendor.costFactors.splice(index, 1);
				vendor.costFactorJson = JSON.stringify(vendor.costFactors);
			}, { autoSave: true });

			setTimeout(actions.popModal, 0);
		};

		const confirmDelete = () => {
			const confirm = <Confirm title={ `Permanently Delete ${factor.description}?` } message={ 'Are you sure you want to permanently delete this factor? This cannot be undone.' } confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ doDelete } />;

			actions.popModal();
			actions.pushModal({ component: confirm });
		};

		const popup = (<Popup target={e.target}><div className="content scrollable">
			<ul className="menu">
				<li><a className="button icon iconLabel removeItem delete" onClick={ confirmDelete }><span>Delete</span></a></li>
			</ul>
		</div></Popup>);

		actions.pushModal({ component: popup });
	}

	createPendingLineItem () {
		return factorFactory({});
	}

	updateModel (key, updater, options) {
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		if (readOnly) { return; }

		this.props.updateModel(vendor => {
			let factor = _.find(vendor.costFactors, { key });

			if ((!factor) && (key === this.state.pendingFactor.key)) {
				factor = this.state.pendingFactor;
				options.autoSave = false;
			}

			if (factor) {
				updater(factor);
				if (options.autoSave) {
					vendor.costFactorJson = JSON.stringify(vendor.costFactors);
				}
			}
		}, options);
	}

	render () {
		const { vendor } = this.props;
		const securityContext = componentServices.securityContext;
		const currentModule = componentServices.routeParams.modulekey;
		const readOnly = !securityContext.currentUserHasFeature(currentModule, 'supplier-basic');

		const rows = _.map(vendor.costFactors, factor => {
			return (
				<FactorRow key={factor.key} updateModel={ this.updateModel.bind(this, factor.key) } buttonHandler={ this.contextMenuHandler.bind(this, factor) } factor={factor} classNames={ ['added', 'dropTarget']} buttonClass="icon iconOnly contextMenu" alwaysValidate={ true } />
			);
		});

		return (
			<section className="expander expanded">
				<div className={ readOnly ? 'inner readOnly' : 'inner'}>

					<table className="compact" cellPadding="0" cellSpacing="0">
						<thead>
							<tr>
								<td />
								<td className=""><span className="readOnly">Description</span></td>
								<td className="cost"><span className="readOnly">Factor</span></td>
								<td className="action" />
								<td />
							</tr>
						</thead>
						<tbody>
							<FactorRow key={this.state.pendingFactor.key} updateModel={this.updateModel.bind(this, this.state.pendingFactor.key)} buttonHandler={this.addLineItemHandler.bind(this, this.state.pendingFactor.key)} factor={this.state.pendingFactor} classNames={ ['addRow'] } buttonClass="icon iconOnly addItem" />
							{ rows }
						</tbody>
					</table>
				</div>
			</section>
		);
	}
}
